var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BaseInput, SliderBase } from '../ui';
import { FormField } from './form-field';
export var Slider = function (_a) {
    var label = _a.label, error = _a.error, description = _a.description, hasInput = _a.hasInput, onChange = _a.onChange, sliderProps = __rest(_a, ["label", "error", "description", "hasInput", "onChange"]);
    return (_jsxs("div", { className: 'flex w-full gap-4 ps-2', children: [_jsx(FormField, { label: label, error: error, description: description, containerClassName: 'w-full', children: _jsx(SliderBase, __assign({ className: 'mb-6', onChange: onChange }, sliderProps)) }), hasInput && (_jsx(BaseInput, { type: 'number', value: sliderProps.value, onChange: function (e) {
                    return onChange(Number(e.target.value) > sliderProps.max ? sliderProps.max : Number(e.target.value));
                }, min: sliderProps.min, max: sliderProps.max, className: '!outline-none bg-gray-200 !w-12 !max-h-8 !rounded-md !ps-2' }))] }));
};
